import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminQuests } from 'containers'

export const AdminQuestRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminQuests />} />
    </Routes>
  )
}
